module.exports = __webpack_public_path__ + "img/bg_3.ea769e55.jpg";